import apiService from "../../api/api.service";
import {
  Address,
  CreateAddressRequest,
  UpdateAddressRequest,
} from "./address.types";
import { ApiResponse } from "../../api/api.types";

/**
 * Get all customer addresses
 */
export const fetchAddresses = () => {
  return apiService.get<ApiResponse<{ items: Address[] }>>("/customer-addresses");
};

/**
 * Get address by ID for editing
 */
export const fetchAddressById = (id: number) => {
  return apiService.get<ApiResponse<Address>>(`/customer-addresses/${id}/edit`);
};

/**
 * Create new address
 */
export const createAddress = (data: CreateAddressRequest) => {
  return apiService.post<ApiResponse<[]>, CreateAddressRequest>(
    "/customer-addresses/store",
    data
  );
};

/**
 * Update existing address
 */
export const updateAddress = (id: number, data: UpdateAddressRequest) => {
  return apiService.post<ApiResponse<[]>, UpdateAddressRequest>(
    `/customer-addresses/${id}/update`,
    data
  );
};

/**
 * Delete address
 */
export const deleteAddress = (id: number) => {
  return apiService.delete<ApiResponse<[]>>(`/customer-addresses/${id}/destroy`);
};

/**
 * Query tax number to get company info
 */
export const queryTaxNumber = (taxNumber: string) => {
  return apiService.get<ApiResponse<{ taxOfficeName: string; title: string; isActive: boolean; eInvoiceResponsible: boolean }>>(
    `/general/query-tax-number?tax_number=${taxNumber}`
  );
};